import { render, staticRenderFns } from "./PackDetail.vue?vue&type=template&id=d8588160&scoped=true"
import script from "./PackDetail.vue?vue&type=script&lang=js"
export * from "./PackDetail.vue?vue&type=script&lang=js"
import style0 from "./PackDetail.vue?vue&type=style&index=0&id=d8588160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8588160",
  null
  
)

export default component.exports